// extracted by mini-css-extract-plugin
module.exports = {"TopLogo":"TopLogo-module--TopLogo--13ZHj"};